import  React, { useEffect, useState } from "react"; import Menubar from "../Menubar"; import {  Container, Row, Col,Form,} from "react-bootstrap"; import { store } from "../../App"; import {Field, FormikProvider, useFormik } from "formik";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import "jspdf-autotable"; import { exportToExcel, datetime, generatePdf, } from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert";  import Select from 'react-select'; import jsPDF from "jspdf"; 
import MasterService from "../../Services/MasterService";

export default function MandalAchievementsprogressReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [data, setData] = useState([]); const [searchText, setSearch] = useState(""); const [Periodicid, setperiodicId] = useState(); const [Periodicitylist, setPeriodicitylist] = useState();const [Yearlist, setYearlist] = useState(); const [Categorylist, setCategorylist] = useState();  const [mainEnb, setMainenb] = useState(true); const [Distname, setDistname] = useState(); const[Depts,setDepts]=useState();const [Deptname, setDeptname] = useState();  const [districts, setdistricts] = useState();
 let district = localStorage.getItem("districtid"); let username = localStorage.getItem("username"); let deptId = localStorage.getItem("deptid"); let secretariatcode = localStorage.getItem("secretariat_code"); let roleid = localStorage.getItem("catid");  const [seclist, setseclist] = useState([]); const [secenb, setsecenb] = useState(false); const [deptenb, setdeptenb] = useState(false); const [distlist,setDistrictList]=useState()
const formik = useFormik({ initialValues: { department_id:"", sec_id:"0" ,year:"",category:""}, onSubmit: (values) => { } })
let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
    useEffect(() => {
      if (roleid === "113" || roleid==="119") {
        formik.setFieldValue("district_id", district);
      }
      MasterService.getDistricts().then((res17) => {
        if (res17.data) {
          setdistricts(res17.data);
           let options = res17.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); }); setDistrictList(options);
        }
      });
    
       let paramss = { userId: username }

      MasterService.getDeptartments(paramss).then((res) => {
                if (res.data) { 
        setDepts(res.data?.SDESC);
        let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); }); 
                const updatedDeptList = [  ...res.data.SDESC, ];
                setseclist(updatedDeptList); } }); 
       if(["116","117","119"].includes(roleid)){ console.log("seclut",seclist);  setsecenb(false); setdeptenb(false); }
  if(["113","111","114"].includes(roleid)) { formik.setFieldValue("sec_id", secretariatcode); setsecenb(true);setdeptenb(true);formik.setFieldValue("department_id", deptId);  }
  // KpiService.getPeriodicitylist(paramss).then((res20) => {
  //   if (res20.data) {
  //     setPeriodiclist(res20.data.SDESC);
  //     let options = res20.data.SDESC.map((item, i) => {
  //       return ( <option key={item.periodic_id} value={item.periodic_id}> {item.periodic_name} </option> );
  //     });
  //     setPeriodicitylist(options);
  //   }
  // })
  if(["113","114","111"].includes(roleid)){formik.setFieldValue("department_id",deptId);
    perioicitylist(deptId);
}

}, []);


const periodicityMap = {monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" },half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" }};

const perioicitylist = (dept) => {formik.setFieldValue("periodic_id","");
  if(!dept){ setPeriodicitylist([]); return; }
    if (dept === "0") {
      const alllOptions = Object.keys(periodicityMap).map((key) => ( <option key={periodicityMap[key].value} value={periodicityMap[key].value}> {periodicityMap[key].label}</option> ));
      
      setPeriodicitylist(alllOptions); return;
    }
  else{
    let param = { userId: username, deptId: dept};
    KpiService.periodicityStatus(param).then((res) => {
      if (res.data) {
        if (res.data.SCODE === "01") {
          const apiData = res.data.SDESC[0]; const options = Object.keys(periodicityMap).filter((key) => apiData[key] > 0).map((key) => ( <option key={periodicityMap[key].value} value={periodicityMap[key].value}> {periodicityMap[key].label} </option> ));
      
          setPeriodicitylist(options);
        } else { setPeriodicitylist([]); showAlertMessage(res.data.SDESC, "warning"); }
      }
    });
}};

const YearData=(e)=>{
  formik.setFieldValue("year",""); formik.setFieldValue("category",""); setperiodicId(e.target.value); setData([]);
    let params={
      userId:username,
      periodicityId:e.target.value
    }
    KpiService.KpiperiodicYears(params).then((res20) => {
      let res=res20.data.SDESC.yearsList
      
      if (res20.data) { let options = res.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); }); setYearlist(options); }
    })
    setYearlist([]); setCategorylist([]);
  
  }

  const Categorydata = (e) => {
    const params = { userId: username, periodicityId: Periodicid, };
  
      KpiService.KpiperiodicYears(params).then((res) => {
        const response = res.data.SDESC.headList;
  if(response){
        const options = response?.map((item, i) => ( <option key={item.id} value={item.id}> {item.value} </option> ));
        setCategorylist(options);
      }
      else{ setCategorylist([]); }
      });
  
  };
  const filteredData = searchText.length > 0 && data?.length ? data.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText.toLowerCase()) ); }) ); }) : data;
  const[currentdate,setcurrentdate] =useState(''); const[currenttime,setcurrenttime] =useState('');

  useEffect(() => { datetime(setcurrentdate,setcurrenttime); }, []);


  const fetchKpiAchievementData = (year,category,deptid ) => {
      const filterdept = Depts?.find(item => item.dept_id === deptid); setDeptname(filterdept?.dept_name);
        


    if (roleid === "114" || roleid === "116") { const filterdistrict = districts?.find(item => item.id === formik.values.district_id); setDistname(filterdistrict?.value); }
    else { setDistname(localStorage.getItem("districtname")); }
    console.log("!Periodicid ||  !year || !category",Periodicid,year,category)
     const isAnyFieldMissing = !Periodicid ||  !year || !category;
    if (isAnyFieldMissing) {
      return;
    }
  
    store.dispatch({ type: "SHOW_SPINNER" });
    const params = { deptId:deptid, userId: username, year: year, periodicityId: Periodicid, headId: category ? category : "0", districtId: formik.values.district_id };
    KpiService.kpisAchievementIndicatorReport(params)
      .then((res) => {
        if (res.data.SCODE === "01") { setData(res.data.SDESC); } else { showAlertMessage(res.data.SDESC, "warning"); setData([]); }
      })
      .catch(() => { showAlertMessage("Error fetching details. Please try again.", "warning"); }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  
  const getdata = (year,category,deptid) => { fetchKpiAchievementData(year, category,deptid); };
    return (
        <>
                                <Menubar />
          <Container className='map-header1' fluid > <div className='sa-title'> <h2>{ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"} Wise- {ulbdeptlist.includes(formik.values.department_id)? "ULB":"Mandal"} Indicators Achievements<span>  Status  Report</span></h2> </div> </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
              <FormikProvider value={formik} >
                        <Form onSubmit={formik.handleSubmit}>
         
 <div className='mandal-container p-4 mt-2'>
              <Row>
             
                                          <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}  > <label className="mb-1 fw-bold"> HOD Name</label>
                                         
                                     <Select className="w-100" isClearable={true} isSearchable={true} name="department_id" required={true} getOptionValue={(option) => option.dept_id} getOptionLabel={(option) => option.dept_name} options={seclist} value={seclist?.find((option) => option.dept_id === formik.values.department_id) || ""} onChange={(option) => { formik.setFieldValue("department_id",option ? option.dept_id : "");perioicitylist(option ? option.dept_id : "");  }} isDisabled={deptenb} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000 }), }} />
                                                               
                                                              </Col> 
                                                           <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'>
    <label htmlFor="year" className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>

      <Field className="mb-3 form-control" component="select" name="district_id" disabled={roleid === "119" || roleid === "113"} style={{ fontWeight: "bold" }} >
                    <option value="">--Select--</option> {distlist}
                  </Field>
    </Col>
                <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'>
                <label htmlFor="periodic_id" className="mb-1 fw-bold"> Periodicity </label> <span style={{ color: "red" }}> *</span>
                  <Field className="mb-3 form-control" component="select" name="periodic_id" controlId="formBasicEmail"  onChange={(e)=>{YearData(e); 
                    formik.handleChange(e)}}style={{ fontWeight: "bold" }}>
                    <option value="">--Select--</option>
                    {Periodicitylist}
                  </Field>
                </Col> 
                
  <>
    <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'>
    <label htmlFor="year" className="mb-1 fw-bold"> Year </label> <span style={{ color: "red" }}> *</span>

      <Field className="mb-3 form-control" component="select" name="year" controlId="formBasicEmail"
       onChange={(e) => {
         Categorydata(e); formik.handleChange(e) ;if(Periodicid === "3"){getdata(e.target.value,"0",formik.values.department_id)}else{
          getdata(e.target.value,formik.values.category,formik.values.department_id)
         }}} style={{ fontWeight: "bold" }} > <option value="">--Select--</option> {Yearlist} </Field>
    </Col>

    {(Periodicid === "5" || Periodicid === "6" || Periodicid === "7")  && (
      <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'>
                          <label htmlFor="category" className="mb-1 fw-bold"> Category </label> <span style={{ color: "red" }}> *</span>
        <Field
          className="mb-3 form-control"
          component="select"
          name="category"
          controlId="formBasicEmail"
          style={{ fontWeight: "bold" }}
          onChange={(e)=>{getdata(formik.values.year,e.target.value,formik.values.department_id); formik.handleChange(e) }}
        >
          <option value="">--Select--</option>
          {Categorylist}
        </Field>
      </Col>
    )}
              </>                              
              </Row>
            </div> 
            {mainEnb&&  
              <>
                <Row className="mt-5">
                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    <div style={{display: "flex",alignItems: "center",border: "1px solid #ddd",borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px",}} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                            <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                            <input type="text" placeholder="Search" value={searchText} onChange={(event) => setSearch(event.target.value)} style={{flex: "1",border: "none",outline: "none",fontSize: "1rem",color: "#333",backgroundColor: "transparent",transition: "color 0.3s ease",minWidth: "0",}}/>
                        </div>
                    </Col>
                    <Col className=" mb-2 " >
                        <button type="button" className="btn btn-danger btn-sm mx-2 pdf-btn" style={{ float: "right", marginLeft: "3px" }} onClick={() => generatePdf("#my-table", "Mandals Achievement Report",11)}> PDF <MdOutlinePictureAsPdf /> </button>
                        <button type="button" variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Mandals Achievement Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
       
</Col>
                </Row>
             
   <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
                 <div id="table-scroll" className="" style={{ maxHeight: '700px', overflowY: 'auto', overflowX: 'hidden' }} >
                    <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered sticky-table">
                        <thead  style={{ position: "sticky", top: 0, zIndex: 2 }}>
                            <tr className="text-center"> <th colSpan={8} style={{ backgroundColor: "#d4e3d8", color: "black" }}> <span style={{color:"black"}}> Statement showing the {ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"} Wise- {ulbdeptlist.includes(formik.values.department_id)? "ULB":"Mandal"} Indicators Achievements Status 
                              <br/>of the HOD: <span style={{color:"#fbb040"}}>{Deptname}</span>,  District: <span style={{color:"#fbb040"}}>{Distname}</span>  and Periodity: <span style={{color:"#fbb040"}}>{Object.values(periodicityMap).find(item => item.value == Periodicid)?.label}</span>
</span> </th></tr>
                        <tr className="only-export"><th  colSpan={8} style={{ backgroundColor: "#d4e3d8", color: "black" }}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>            
                            
                            <tr className="text-center">
                                <th style={{ backgroundColor: "#1143913", color: "white" }} >Sl.No.</th> 
                                <th style={{ backgroundColor: "#1143913", color: "white" }} >{ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"}</th> 
                                <th style={{ backgroundColor: "#1143913", color: "white" }}>Entered</th>
                                <th style={{ backgroundColor: "#1143913", color: "white" }}>Not Entered</th> <th style={{ backgroundColor: "#1143913", color: "white" }}>Approved</th> <th style={{ backgroundColor: "#1143913", color: "white" }}>Not Approved</th>
                              
                            </tr>
                        </thead>
                       
  <tbody>
    {filteredData?.length === 0 || filteredData?.length === undefined ? ( <tr> <td className="text-center" colSpan="11"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr> ) : (
      (() => {
        
        return filteredData?.map((detail, i) => {
        

          return (
            <tr key={i}>
              <td style={{ textAlign: "center" }} >{i + 1}</td>
             
                                <td style={{textAlign:"left"}} >{detail.mandal_name}</td> <td style={{textAlign:"right"}}>{detail.entered_indicators}</td> <td style={{textAlign:"right"}}>{detail.not_entered_indicators}</td>
                                <td style={{textAlign:"right"}}>{detail.approved_indicators}</td>
                                <td style={{textAlign:"right"}}>{detail.not_approved_indicators}</td>
            </tr>
          ); }); })() )}
  </tbody>
       <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#e6e6e6", fontWeight: "bold" }}>
      <td colSpan={2} style={{ backgroundColor: "#1143913", color: "white", textAlign: "right" }} >Total</td> <td style={{ backgroundColor: "#1143913", color: "white",textAlign: "right" }}> {filteredData?.reduce((sum, item) => sum + (parseFloat(item.entered_indicators) || 0), 0)} </td> <td style={{backgroundColor: "#1143913", color: "white", textAlign: "right" }}> {filteredData?.reduce((sum, item) => sum + (parseFloat(item.not_entered_indicators) || 0), 0)} </td>
      <td style={{ backgroundColor: "#1143913", color: "white",textAlign: "right" }}> {filteredData?.reduce((sum, item) => sum + (parseFloat(item.approved_indicators) || 0), 0)} </td> <td style={{ backgroundColor: "#1143913", color: "white",textAlign: "right" }}> {filteredData?.reduce((sum, item) => sum + (parseFloat(item.not_approved_indicators) || 0), 0)} </td>
    </tr>
  </tfoot>
 




</table> </div> </>}</Form> </FormikProvider> </Container> <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> </> ); }
 
 